export default {
	events: (state, getters) => (type) => {
		return state[type] ? state[type].items.map((event) => {
			event.isUnlocked = getters['user/hasAccessToEvent'](event);
			return event;
		}) : [];
	},
};
